import { render } from "./Home.vue?vue&type=template&id=69035c49"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"

import "./Home.vue?vue&type=style&index=0&id=69035c49&lang=scss"

import exportComponent from "D:\\react js\\VET_VUE\\VET-mini-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__